export default __webpack_public_path__ + "images/IOS.ef0a797.png";